export const CURRENT_SEASON_ID = 20; // internal season id
export const REAL_CURRENT_SEASON = 13; // actual season number

// C19
export const C19_PROMOTION = false;

// RESPONSIVE
export const DEFAULT_BREAKPOINT = "DESKTOP_LARGE";
export const WINDOW_BREAKPOINTS_RANGE = {
  MOBILE_SMALL: [0, 399],
  MOBILE_MEDIUM: [400, 599],
  MOBILE_LARGE: [600, 899],
  TABLET: [900, 1139],
  DESKTOP_SMALL: [1140, 1359],
  DESKTOP_MEDIUM: [1360, 1469],
  DESKTOP_LARGE: [1470, 9999999999],
};

export const WINDOW_BREAKPOINTS = {
  MOBILE: ["MOBILE_SMALL", "MOBILE_MEDIUM", "MOBILE_LARGE"],
  TABLET: "TABLET",
  DESKTOP: ["DESKTOP_SMALL", "DESKTOP_MEDIUM", "DESKTOP_LARGE"],
};

export const MOBILE_SLIDE_GLOBAL_KEY = "mobalSlideClass";

export const OG_CONTEST_ALERT_LIMIT = 259200000; // 3 days
export const OG_CONTEST_DEADLINE = 1646283599000; // March 2
// export const OG_CONTEST_DEADLINE = 1647489599000; // March 16
// export const OG_CONTEST_DEADLINE = 1648699199000; // March 30

// JSON FETCHER CACHE KEY
export const OVERVIEW_PLATPLUS_WORLD = "overview_platplus_world";
export const OVERVIEW_PLATPLUS_WORLD_AP = "overview_platplus_world_ap";
export const OVERVIEW_PLATPLUS_WORLD_CT = "overview_platplus_world_ct";
export const RANKINGS_PLATPLUS_WORLD = "rankings_platplus_world";
